import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const name = 'getEmailRuleList'

export default () => (asyncAction(
  name,
  EmailRulesService.getEmailRuleList
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/email-rules/getEmailRuleList.js